// extracted by mini-css-extract-plugin
export default {"projectSection":"HomeProjectStyles_projectSection__Mf5AW","lightTheme":"HomeProjectStyles_lightTheme__LDUmA","darkTheme":"HomeProjectStyles_darkTheme__Ye7SK"};